import React from 'react';

import {RelevantItemsGraphQL} from 'relevant-items/__generated/RelevantItemsGraphQL';
import {getEntityRelevantItemRowData} from 'relevant-items/getEntityRelevantItemsRowData';
import {RelevantItemsFilteredTableState} from 'relevant-items/PresentationalRelevantItemsSection';
import RelevantItemsTable from 'relevant-items/shared/RelevantItemsTable';

export interface RelevantItemsSectionTableProps {
  relevantItemsGraphQL: RelevantItemsGraphQL;
  relevantConvertedFromItemsGraphQL: RelevantItemsGraphQL | null;
  filteredTableState: RelevantItemsFilteredTableState;
  setFilteredTableState: (state: RelevantItemsFilteredTableState) => void;
  itemId: string;
  /** @default false */
  isCompact?: boolean;
  /** @default 100 */
  paginationLimit?: number;
}

/**
 * Table part of the relevant items section.
 *
 * @package This is meant for internal use, and should not generally be directly rendered; rather, use either
 * PresentationalRelevantItemsSection or RelevantItemsSection.
 *
 */
export default function RelevantItemsSectionTable({
  relevantItemsGraphQL,
  relevantConvertedFromItemsGraphQL,
  filteredTableState,
  setFilteredTableState,
  itemId,
  isCompact,
  paginationLimit,
}: RelevantItemsSectionTableProps): JSX.Element {
  const rowData = getEntityRelevantItemRowData({
    relevantItemsGraphQL,
    relevantConvertedFromItemsGraphQL,
    filteredTableState,
  });
  return (
    <RelevantItemsTable
      rowData={rowData}
      searchQuery={filteredTableState.searchQuery}
      pageOffset={filteredTableState.pageOffset}
      setPageOffset={(pageOffset) => {
        setFilteredTableState({...filteredTableState, pageOffset});
      }}
      sortStateId={itemId}
      isCompact={isCompact}
      paginationLimit={paginationLimit}
    />
  );
}
